<template>
    <div class="footer" :class="{ 'footer-country' : routeCountry }">
        <p>Спецпроект</p>
        <a href="#" class="header-heart"  :class="{ 'social-icon-color' : !routeCountry &&  !GET_LOAD && $root.isMobile }">
            <Heart class="header-heart__svg"></Heart>
            <div class="header-social">
                <share-link network="fb"  url="http://megafontravel.afisha.ru" class="facebook-link" @click="gaSend('Share fb')">
                    <FB class="icon-svg"></FB>
                </share-link>
                <share-link network="ok"  url="http://megafontravel.afisha.ru" class="ok-link" @click="gaSend('Share ok')">
                    <OK class="icon-svg"></OK>
                </share-link>
                <share-link network="vk"  url="http://megafontravel.afisha.ru" class="vk-link" @click="gaSend('Share vk')">
                    <VK class="icon-svg"></VK>
                </share-link>
                <share-link network="tw"  url="http://megafontravel.afisha.ru" class="twitter-link" @click="gaSend('Share tw')">
                    <TW class="icon-svg"></TW>
                </share-link>
                <share-link network="tg"  url="http://megafontravel.afisha.ru" class="telegram-link" @click="gaSend('Share tg')">
                    <TG class="icon-svg"></TG>
                </share-link>
            </div>
        </a>
    </div>
</template>

<script>
    import {TweenMax} from 'gsap'
    import {mapGetters} from 'vuex';
    import Helpers from '@/tools/Helpers'

    import Heart from '@/assets/svg/heart.svg';
    import VK from '@/assets/svg/vk.svg';
    import FB from '@/assets/svg/facebook.svg';
    import TW from '@/assets/svg/tw.svg';
    import TG from '@/assets/svg/telegram.svg';
    import OK from '@/assets/svg/ok.svg';

    export default {
        name: 'footerApp',
        components: {
            Heart,
            VK,
            FB,
            TW,
            TG,
            OK,
        },
        computed: {
            routeCountry() {
                return this.$route.name == 'Country'
            },
            ...mapGetters(['GET_LOAD']),
        },
        methods: {
            gaSend(index) {
                Helpers.ga().send( 'Footer', 'Click', index);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// footerApp.vue?ef21af1e